<template>
  <div :id="element">
    <v-app>
      <v-main>
        <aspediacrm-grid
          :map="map"
          :global-context="globalContext"
        />
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'aspediacrm-grid-app',
  props: {
    element: {
      type: String,
      required: true,
      default: 'aspedia-crm-grid'
    },
    map: {
      type: Object,
      required: true
    },
    globalContext: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>

<style>

</style>
